"use client";
import React from "react";
import LeadFormFieldsSkeleton from "./leadform-fields-skeleton";

/**
 * Full-page skeleton for lead form pages (request info, prospectus).
 * Matches the two-column layout: UniversityCard (left) + LeadFormSection (right).
 */
const LeadFormPageSkeleton = () => {
  return (
    <section className="bg-grey-50 py-[24px]">
      <div className="flex flex-col lg:flex-row gap-[24px] md:gap-[40px] items-start justify-center max-w-[1054px] mx-auto lg:px-[16px] xl:px-0">
        {/* University card skeleton (left column) */}
        <div className="w-full lg:w-[416px] lg:shrink-0 md:w-[598px] md:mx-auto order-2 lg:order-1">
          <div className="border border-grey-200 rounded-[8px] overflow-hidden bg-white">
            {/* Hero image */}
            <div className="skeleton skeleton-text-animated !h-[180px] w-full !m-0"></div>
            {/* Logo + name + rating */}
            <div className="p-[16px] flex flex-col gap-[12px]">
              <div className="flex items-center gap-[12px]">
                <div className="skeleton skeleton-text-animated !w-[48px] !h-[48px] !rounded-[8px] !m-0"></div>
                <div className="flex flex-col gap-[4px] flex-1">
                  <div className="skeleton skeleton-text-animated !h-[18px] !w-[200px] !m-0"></div>
                  <div className="flex items-center gap-[4px]">
                    <div className="skeleton skeleton-text-animated !h-[14px] !w-[60px] !m-0"></div>
                    <div className="skeleton skeleton-text-animated !h-[14px] !w-[80px] !m-0"></div>
                  </div>
                </div>
              </div>
              {/* Review cards */}
              <div className="skeleton skeleton-text-animated !h-[100px] w-full !rounded-[8px] !m-0"></div>
            </div>
          </div>
        </div>

        {/* Lead form skeleton (right column) */}
        <div className="w-full md:w-[598px] md:mx-auto lg:flex-1 order-1 lg:order-2">
          <LeadFormFieldsSkeleton />
        </div>
      </div>

      {/* Logo footer */}
      <div className="flex items-center justify-center gap-[16px] px-[16px] md:gap-[24px] mt-[24px] md:mt-[40px] w-full md:w-[598px] md:mx-auto lg:ml-auto lg:mr-[calc((100vw-1054px)/2)]">
        <div className="skeleton skeleton-text-animated !h-[24px] !w-[120px] !m-0"></div>
      </div>
    </section>
  );
};

export default LeadFormPageSkeleton;
